import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelperService } from '../helper.service';
import { Partners } from '../partner.model';
import { PartnerService } from '../partner.service';

@Component({
  selector: 'partner-registration',
  templateUrl: './partner-registration.component.html',
  styleUrls: ['./partner-registration.component.css']
})
export class PartnerRegistrationComponent implements OnInit {

  //declare variables
  p: Partners = new Partners();
  bRobot: boolean = false;

  //inject services
  constructor(private ps: PartnerService, private router: Router, private hs: HelperService) { }

  ngOnInit(): void {
    
  }

  //save a new contact
  save() {
    //update some of the data
    this.p.dateSubmitted = new Date();
    this.p.id = this.hs.createGUID();

    //save the record
    this.ps.save(this.p);

    //clear the form
    this.p = new Partners();
    this.bRobot = false;

    //navigate to the thank you page
    this.router.navigate(['/thank-you/partner']);
  }

}
